import React from 'react'
import { Spinner } from '../Spinner'
import style from './style.module.scss'

type loadMoreButtonProps = {
    showButton: boolean
    picto?: string
    buttonText?: string
    isLoading: boolean
    onClick: () => void
}

export const LoadMoreButton: React.FC<loadMoreButtonProps> = ({
    showButton,
    buttonText = 'Afficher plus',
    picto = 'fi-rs-plus',
    isLoading,
    onClick,
}) => {
    if (!showButton) {
        return null
    }
    return (
        <div className={style.buttonContainer}>
            {isLoading ? (
                <div className={style.loading}>
                    <Spinner size="1em" className={style.spinner} />
                    <span>Chargement...</span>
                </div>
            ) : (
                <button className={style.button} onClick={onClick}>
                    <i className={`fi ${picto}`} />
                    <span>{buttonText}</span>
                </button>
            )}
        </div>
    )
}
